export const extractPath = (path) => {
  return path.split('/').filter(Boolean);
};

export const buildTreeDeviceGroup = (records) => {
  const { TbDeviceGroup = [] } = records;
  const isRootGroup = {};
  const groups = {};

  // Prepare node map
  TbDeviceGroup.forEach((device) => {
    Object.entries(device.deviceGroups).forEach(([groupId, group]) => {
      const treeNode = {
        group,
        subGroups: [],
      };

      groups[groupId] = treeNode;
    });
  });

  // Build tree
  TbDeviceGroup.forEach((device) => {
    const path = extractPath(device.deviceGroupPath);

    const rootGroupId = path[0];

    isRootGroup[rootGroupId] = true;

    for (let i = 1; i < path.length; i++) {
      const currentGroupId = path[i];
      const parentGroupId = path[i - 1];

      if (
        !groups[parentGroupId].subGroups.find(
          (group) => group.group.id === Number(currentGroupId)
        )
      ) {
        groups[parentGroupId].subGroups.push(groups[currentGroupId]);
        groups[parentGroupId].subGroups.sort((a, b) =>
          a.group.name.localeCompare(b.group.name)
        );
      }
    }
  });

  console.log('buildTree', records);

  return {
    rootGroups: Object.values(groups).filter(
      (group) => isRootGroup[group.group.id]
    ),
    allGroups: groups,
    TbDevice: [],
  };
};

export const buildTreeCameras = (records) => {
  const { TbDeviceGroupMember = [] } = records;
  const isRootGroup = {};
  const groups = {};

  // Prepare node map
  TbDeviceGroupMember.forEach((device) => {
    Object.entries(device.deviceGroups).forEach(([groupId, group]) => {
      const treeNode = {
        group,
        cameras: [],
        subGroups: [],
      };

      groups[groupId] = treeNode;
    });
  });

  // Build tree
  TbDeviceGroupMember.forEach((device) => {
    const path = extractPath(device.deviceGroupPath);

    const rootGroupId = path[0];
    const parentGroupId = path.at(-1);

    if (
      parentGroupId &&
      !groups[parentGroupId].cameras.find((c) => c.serial === device.serial)
    ) {
      groups[parentGroupId].cameras.push(device);
    }

    isRootGroup[rootGroupId] = true;

    for (let i = 1; i < path.length; i++) {
      const currentGroupId = path[i];
      const parentGroupId = path[i - 1];

      if (
        !groups[parentGroupId].subGroups.find(
          (group) => group.group.id === Number(currentGroupId)
        )
      ) {
        groups[parentGroupId].subGroups.push(groups[currentGroupId]);
      }
    }
  });

  return {
    rootGroups: Object.values(groups).filter(
      (group) => isRootGroup[group.group.id]
    ),
    allGroups: groups,
    TbDevice: records.TbDevice || [],
  };
};

export const buildTree = (records, applicationType = 'device') => {
  if (applicationType === 'device-group') {
    return buildTreeDeviceGroup(records);
  }

  return buildTreeCameras(records);
};

const uniqueTbDeviceGroupMember = (list) => {
  return Array.from(
    new Map(
      list.map((item) => [item.serial + '|' + item.deviceGroupPath, item])
    ).values()
  );
};

const uniqueTbDevice = (list) => {
  return Array.from(new Map(list.map((item) => [item.serial, item])).values());
};

const uniqueDeviceGroup = (list) => {
  return Array.from(new Map(list.map((item) => [item.id, item])).values());
};

export const mergeData = (prev, next) => {
  return {
    ...next,
    records: {
      TbDeviceGroupMember: uniqueTbDeviceGroupMember([
        ...(prev.records.TbDeviceGroupMember || []),
        ...(next.records.TbDeviceGroupMember || []),
      ]),
      TbDevice: uniqueTbDevice([
        ...(prev.records.TbDevice || []),
        ...(next.records.TbDevice || []),
      ]),
      TbDeviceGroup: uniqueDeviceGroup([
        ...(prev.records.TbDeviceGroup || []),
        ...(next.records.TbDeviceGroup || []),
      ]),
    },
  };
};
